import { useEffect, useContext, useState, useMemo, useCallback } from "react";
import { HotelContext } from "../context/hotel";
import useApi from "./useApi";
import {
    normalizeReviewFlow,
    normalizeReviewQuestionBlocks,
    getEffectiveReviewSettingType,
} from "../components/Reviews/reviewQuestionBlocks";

/** Normaliza la respuesta de POST /reviews (GenericResponse / variantes). */
export const extractCreatedReviewIdFromApiResult = (api_result) => {
    if (api_result == null) return null;
    const st = api_result.status;
    const ok = st === true || st === "true" || st === 1;
    if (!ok) return null;
    let payload = api_result.data;
    if (payload == null) return null;
    if (typeof payload === "string") {
        try {
            payload = JSON.parse(payload);
        } catch {
            return null;
        }
    }
    const id = payload?.id ?? payload?.reviewId;
    return id != null && id !== "" ? String(id) : null;
};

export const useReviews = (id) => {
    const { get, post, put } = useApi();
    const { data: hotel } = useContext(HotelContext)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [doneRating, setDoneRating] = useState(false);

    useEffect(() => {
        if (!id) return;
        getSettingById(id)
    }, [id])

    const getSettingById = async (id) => {
        setLoading(true);
        try {
            const response = await get(`hotels/${hotel.id}/reviews_settings/${id}`);
            setData(response);
            setLoading(false);
            return response;
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
            throw error;
        }
    };

    // const getSettingById = useCallback((id) => {
    //     setLoading(true);
    //     return byId(id, hotel.id).then(r => {
    //         setData(r);
    //         setLoading(false);
    //     })
    // }, [hotel]);

    const questions = useMemo(() => {
        return normalizeReviewQuestionBlocks(data?.questions);
    }, [data])

    const reviewFlow = useMemo(() => {
        return normalizeReviewFlow(data?.questions);
    }, [data]);

    const reviewSettingType = useMemo(() => getEffectiveReviewSettingType(data), [data]);

    const create = useCallback(async (settingId, value, checkInId = null, requestId = null) => {
        const api_result = await post(`hotels/${hotel.id}/reviews`, {
            "reviewSettingId": settingId,
            "checkInId": checkInId,
            "requestId": requestId,
            "review": value
        });
        console.log('20ago api_result interno', api_result);
        return extractCreatedReviewIdFromApiResult(api_result);
    }, [post, hotel?.id]);

    const update = useCallback(async (id, data) => {
        console.log('20ago - update - id', id)
        console.log('20ago - update - x', data)
        const api_result = await put(`hotels/${hotel.id}/reviews/${id}`, data);
        console.log('20ago api_result interno', api_result);
        return api_result;
    }, [put, hotel?.id]);

    // const comment = (id, comment) => {
    //     return commentAction(id, comment)
    // }

    return {
        loading,
        data,
        create,
        update,
        questions,
        reviewFlow,
        reviewSettingType,
        doneRating,
        setDoneRating
    }

}